export type CampaignDeliveryHealth = {
  blocking: boolean;
  severity: 'warning' | 'error';
  code: string;
  title: string;
  message: string;
  impact: string;
  action: string;
  feed_name: string;
  since: string | null;
  last_success_at: string | null;
  next_attempt_at: string | null;
};
const date = (value: string) => new Date(value).toLocaleString('pt-BR', {timeZone: 'America/Sao_Paulo'});
export function CampaignDeliveryAlert({health}: {health?: CampaignDeliveryHealth | null}) {
  if (!health?.blocking) return null;
  return <section role="alert" aria-label={health.title} className={`mb-5 rounded-xl border p-4 text-sm break-words ${health.severity === 'error' ? 'border-rose-300 bg-rose-50 text-rose-950' : 'border-amber-300 bg-amber-50 text-amber-950'}`}>
    <h3 className="font-semibold text-base">{health.title}</h3>
    <p className="mt-1 font-medium">{health.message}</p>
    <p className="mt-1">{health.impact}</p>
    <dl className="mt-3 grid gap-x-6 gap-y-1 sm:grid-cols-2">
      <div><dt className="inline font-medium">Catálogo: </dt><dd className="inline">{health.feed_name}</dd></div>
      {health.since && <div><dt className="inline font-medium">Pendente desde: </dt><dd className="inline">{date(health.since)} (Brasília)</dd></div>}
      {health.last_success_at && <div><dt className="inline font-medium">Última sincronização concluída: </dt><dd className="inline">{date(health.last_success_at)} (Brasília)</dd></div>}
      {health.next_attempt_at && <div><dt className="inline font-medium">Próxima tentativa: </dt><dd className="inline">{date(health.next_attempt_at)} (Brasília)</dd></div>}
    </dl>
    <p className="mt-3">{health.action}</p>
  </section>;
}
